/* global __APP_VERSION__ */
import './index.scss';
import clsx from 'clsx';

import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  Route,
  Switch,
  Link,
  NavLink,
  matchPath,
  Redirect,
} from 'react-router-dom';
import _ from 'lodash';
import {
  getData,
  showAppLoader,
  hideAppLoader,
  showToast,
  setCookie,
} from '../../globalFunction';

import { ResponsiveShell } from './shell/ResponsiveShell';
import { clientLanding } from './shell/clientLanding';
import { isInternalUser, isExternalUser, meProjectIds } from './shell/userKind';
import LogActivity from './Modal/LogActivityTime/LogActivityTime';
import { NOTIFICATION_PATH } from '@/routes';
import AddCompany from '../project/Company/components/AddCompany/AddCompany';
import Proceed from '../project/Company/components/Modal/Proceed/Proceed';
import Spinner from '../common/Elements/Spinner/Spinner';
import Icon from '../common/Elements/Icon/Icon';
import { Icons } from '@/assets/icons';
import Axios from '@/axiosPool';

import LookerReport from '../project/Dashboard/components/LookerReport/LookerReport';

import CookieConsentModal from './CookieConsentModal/CookieConsentModal';
import AccountsHome from '../accounts/AccountsHome';
import { mapMePermissions } from '@/api/mappers/mePermissions';
const Home = lazy(() => import('../home/Home'));
const Projects = lazy(() => import('../project'));
const Reports = lazy(() => import('../reports'));
const CompanyEmailLog = lazy(() => import('../admin/EmailLog/CompanyEmailLog'));
const MyTasks = lazy(() => import('../myTasks2/MyTasks'));
const MyTimekeep = lazy(() => import('../myTimekeep'));
const MyConversations = lazy(
  () => import('../myConversations/MyConversations')
);
const Users = lazy(() => import('../users'));
const Profile = lazy(() => import('../profile'));
const Developer = lazy(() => import('../developer'));
const AdminReports = lazy(() => import('../adminReports/AdminReports'));
const Settings = lazy(() => import('../settings'));
const LegalInformationCenter = lazy(() => import('../legalInformationCenter'));
const notAvailable = lazy(() => import('../notAvailable'));
const inactiveProject = lazy(() => import('../inactiveProject'));
const error404 = lazy(() => import('../404'));
const NotificationsPopup = lazy(() => import('./Notifications/Notifications'));
const Notifications = lazy(() => import('../notification'));

let keyTimer = '';
const USER_TEAM = '/users';
@connect(
  (store) => ({
    user: store.loggedUser.data,
    project: store.project,
    me: store.me,
    reminder: store.reminder,
    loggedUser: store.loggedUser,
    notification: store.notification,
    settings: store.settings,
    workstreams: store.workstreams,
    common: store.common,
    conversation: store.conversation,
    globalConfig: store.globalConfig,
    socket: store.socket.container,
  }),
  null,
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  })
)
class Main extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    try {
      getData('/api/me', {}, (response) => {
        if (response && response.data && response.status === 200) {
          const permissions = mapMePermissions(response.data.permissions);
          // `me` is the canonical, cross-client home for the logged-in
          // user (web SPA + iOS read the same /me payload). The shell and
          // staff-only chrome read from here, default-deny until loaded.
          dispatch({
            type: 'SET_ME',
            me: {
              userType: response.data['user-type'],
              permissions,
              projects: response.data.projects || [],
            },
          });
          // Legacy dispatches kept until their readers (AccountsPage,
          // CreateAccountFab) migrate onto the `me` slice.
          dispatch({
            type: 'SET_USER_PROJECTS',
            projects: response.data.projects,
          });
          dispatch({
            type: 'SET_USER_TYPE',
            userType: response.data['user-type'],
          });
          dispatch({ type: 'SET_ME_PERMISSIONS', permissions });
        } else {
          showToast('error', 'Failed to load user data.');
        }
      });
    } catch (err) {
      showToast('error', 'An error occurred while loading user data.');
    }
    // Remove all timeouts here
  }

  constructor(props) {
    super(props);
    this.state = {
      showLeft: true,
      showMore: '',
      reminderCount: 0,
      getReminder: true,
    };
    _.map(['showLeft', 'handleAdd'], (fn) => {
      this[fn] = this[fn].bind(this);
    });
  }

  showLeft() {
    const { dispatch, common } = this.props;

    dispatch({
      type: 'COMMON_UPDATE_SIDEPANEL_STATUS',
      status: common.sidepanelStatus === 'default' ? 'icon-only' : 'default',
    });
  }
  UNSAFE_componentWillMount() {
    const { dispatch, user, location } = this.props;

    dispatch({
      type: 'UPDATE_SETTINGS',
      value: { app_version: __APP_VERSION__ },
    });

    getData(`/api/globalConfig`, {}, (c) => {
      if (c.data) {
        const group = _.groupBy(c.data.results, 'name');
        console.log('group', group);
        dispatch({ type: 'SET_GLOBAL_CONFIG_LIST', global: group });
      }
    });

    if (window.innerHeight <= 550) {
      this.setState({ showMore: '' });
      $('body').css('overflow-y', 'auto').css('min-height', '550px');
      $('html').scrollTop(0);
    } else {
      this.setState({ showMore: 'bottom' });
    }
    $(window).resize(() => {
      if (window.innerHeight <= 550) {
        this.setState({ showMore: '' });
        $('#menu').css('overflow', 'hidden').css('margin-top', '0px');
        $('body').css('overflow-y', 'auto').css('min-height', '550px');
      } else {
        this.setState({ showMore: 'bottom' });
        $('body').css('overflow-y', '').css('min-height', '');
        $('html').scrollTop(0);
      }
    });
  }

  setSideMenuState(status) {
    this.setState({ miniSideMenu: status });
    setCookie('sidemenu', status, 1);
  }

  setShowMore(type) {
    if (type === 'top') {
      $('#menu')
        .css('overflow', 'hidden')
        .css(
          'margin-top',
          '-' + (window.innerHeight < 767 ? 767 - window.innerHeight : 0) + 'px'
        );
    } else {
      $('#menu').css('overflow', 'hidden').css('margin-top', '0px');
    }
    this.setState({ showMore: type });
  }

  handleAdd(type) {
    const { dispatch, history, location } = this.props;
    let formType = '';
    let selectedType = '';
    const id = Math.floor(Math.random() * 11);
    switch (type) {
      case 'task':
        if (location.pathname !== '/my-tasks') {
          dispatch({ type: 'CLEAR_TASKS_DATA' });
          history.push(`/my-tasks?action=add`);
        } else {
          $('#task-form').modal('show');
        }

        selectedType = 'SET_TASK_SELECTED';
        break;
      case 'company':
        dispatch({ type: 'SET_PROJECT_ADD_TYPE', addType: type });
        $('#addCompanyModal').modal('show');

        break;
      case 'project':
        dispatch({ type: 'SET_PROJECT_ADD_TYPE', addType: type });
        $('#addCompanyModal').modal('show');

        break;
      case 'user':
        if (location.pathname !== USER_TEAM) {
          history.push(USER_TEAM + '?action=add');
        } else {
          $('#addNewUsersTeams').modal('show');
        }

        formType = 'SET_USER_FORM_ACTIVE';
        selectedType = 'SET_USER_SELECTED';
        break;
    }

    // dispatch({ type: formType, FormActive: "Form" });
    dispatch({ type: selectedType, Selected: {} });
  }

  _handleLogout = () => {
    const { loggedUser, socket } = this.props;

    // Show the branded loader immediately so the session-destroy + redirect
    // isn't a frozen/white screen (notably on slow connections).
    showAppLoader();

    Axios.delete(`/api/login/${loggedUser.data.id}`)
      .then(() => {
        socket.disconnect();
        // Go straight to /auth — "/" only 302-redirects to /auth when logged
        // out, and that extra round-trip is pure white screen during the hard
        // navigation. Hitting /auth directly removes one server hop, so /auth's
        // static boot loader paints sooner. Loader stays up through the navigation.
        window.location.replace('/auth');
      })
      .catch(() => {
        // Logout failed — drop the loader so the user isn't stuck behind it.
        hideAppLoader();
        showToast('error', 'Failed to log out. Please try again.');
      });
  };

  render() {
    const { showLeft } = this.state;
    const { project, loggedUser, me, settings, workstreams, conversation } =
      this.props;
    const { avatar } = loggedUser.data;
    // User-kind comes from /me (the cross-client source of truth), default-deny:
    // staff-only chrome renders only once /me confirms Internal. Before that —
    // and for clients — `isInternal` is false, so the staff modals below never
    // mount and a client never hits the code paths that crash on a missing role.
    const isInternal = isInternalUser(me);
    // The client landing redirect uses confirmed-External (never the unknown
    // state) and sources project ids from /me, so it stays correct in the SPA.
    const clientRedirect = clientLanding(isExternalUser(me), meProjectIds(me));
    let pages = [
      {
        label: 'Accounts',
        icon: 'fa-building',
        path_name: '',
        component: AccountsHome,
        exact: true,
        show_menu: true,
        isAvailable: true,
      },
      {
        label: 'My Tasks',
        icon: 'fa-list',
        path_name: 'my-tasks',
        component: MyTasks,
        show_menu: true,
        isAvailable: true,
      },
      {
        label: 'My Timekeep',
        icon: 'fa-list',
        path_name: 'my-timekeep',
        component: MyTimekeep,
        show_menu: loggedUser.data.userRole < 5,
        isAvailable: loggedUser.data.userRole < 5,
      },
      {
        label: 'My Conversations',
        icon: 'fa-comments',
        path_name: 'my-conversations',
        component: MyConversations,
        show_menu: true,
        isAvailable: true,
      },
      {
        label: 'Users',
        icon: 'fa-users',
        path_name: 'users',
        component: Users,
        show_menu: loggedUser.data.userRole < 4,
        isAvailable: loggedUser.data.userRole < 4,
      },
      {
        label: 'Projects',
        icon: 'fa-calendar',
        path_name: 'projects',
        component: Projects,
        show_menu: true,
        isAvailable: true,
      },
      {
        label: 'Reports',
        icon: 'fa-calendar',
        path_name: 'reports',
        component: Reports,
        show_menu: loggedUser.data.userRole <= 4,
        isAvailable: loggedUser.data.userRole <= 4,
      },
      {
        label: 'Email Log',
        icon: 'fa-envelope',
        path_name: 'email-log',
        component: CompanyEmailLog,
        // Company-wide email log (crashed-mail triage): Manager and above only
        // (roles 1-3 = Master Admin, Admin, Manager). Was `<= 4`, which also
        // exposed it to Staff. Recovery actions stay admin-only (BE canManage).
        show_menu: loggedUser.data.userRole <= 3,
        isAvailable: loggedUser.data.userRole <= 3,
      },
      {
        label: 'Developer',
        icon: 'fa-code',
        path_name: 'developer',
        component: Developer,
        show_menu: loggedUser.data.userRole < 3,
        isAvailable: loggedUser.data.userRole < 3,
      },
      {
        label: 'Admin Reports',
        icon: 'fa-file-text-o',
        path_name: 'report-definitions',
        component: AdminReports,
        show_menu: loggedUser.data.userRole < 3,
        isAvailable: loggedUser.data.userRole < 3,
      },
      {
        label: 'Settings',
        icon: 'fa-cog',
        path_name: 'settings',
        component: Settings,
        show_menu: loggedUser.data.userRole < 3,
        isAvailable: loggedUser.data.userRole < 3,
      },
      {
        label: 'Legal Information Center',
        path_name: 'legal-information-center',
        component: LegalInformationCenter,
        show_menu: true,
        isAvailable: true,
      },
      {
        label: 'My Account',
        path_name: 'profile',
        component: Profile,
        show_menu: false,
        isAvailable: true,
      },
      {
        label: '',
        path_name: 'not-found',
        component: notAvailable,
        isAvailable: true,
      },
      // {
      //     label: "Notification",
      //     path_name: "notification",
      //     component: Notification,
      //     show_menu: false,
      //     isAvailable: true
      // },
      {
        label: '',
        path_name: 'inactive-project',
        component: inactiveProject,
        show_menu: false,
        isAvailable: true,
      },
      {
        label: '',
        path_name: '404',
        component: error404,
        show_menu: false,
        isAvailable: true,
      },
      {
        label: 'All Updates',
        path_name: 'notifications',
        component: Notifications,
        show_menu: false,
        isAvailable: true,
        exact: true,
      },
    ];
    let dropdownAddLinks = [
      { id: 'task', label: 'Task' },
      { id: 'company', label: 'Company' },
      { id: 'project', label: 'Project' },
      { id: 'user', label: 'User' },
    ];
    if (loggedUser.data.userRole > 3) {
      dropdownAddLinks = [
        { id: 'task', label: 'Task' },
        { id: 'project', label: 'Project' },
      ];
    }

    if (!isInternal) {
      pages = _.filter(pages, ({ path_name }) => {
        return path_name !== 'users';
      });
    }

    const currentPath = this.props.location.pathname;
    const parentPath = currentPath.split('/')[1];
    const currentPage =
      _.find(pages, (page) => {
        return page.path_name === parentPath;
      }) ||
      _.find(pages, (page) => {
        return page.path_name === 'not-found';
      });

    const getProjectDetailsPath = currentPath.split('/');
    const currentProjectPage =
      typeof getProjectDetailsPath[3] === 'undefined'
        ? 'dashboard'
        : getProjectDetailsPath[3];
    const label = project.Type === 'company' ? 'Company List' : 'Project List';
    const path = window.location.href.replace(/^.*[\\\/]/, '');
    let header =
      currentPage?.label !== 'Projects'
        ? currentPage.label
        : path === 'projects'
          ? label
          : '';
    const inactive = path === 'inactive-project';
    const hasInactiveData = localStorage.getItem('inactive_project')
      ? JSON.parse(localStorage.getItem('inactive_project'))
      : null;
    let projectPic = project.Selected.picture;
    if (!header && inactive && hasInactiveData) {
      header = hasInactiveData.project;
      projectPic = hasInactiveData.picture;
    }

    return (
      <>
        <ResponsiveShell
          history={this.props.history}
          onLogout={this._handleLogout}
        >
          <Suspense fallback={<Spinner />}>
            <div
              id="content"
              class={`${currentPage.path_name} ${currentProjectPage} ${currentProjectPage === 'workstreams' ? `workstream_${workstreams.pageType}` : ''} ${header === 'Company List' || header === 'Project List' ? `projectListContainer` : ''}`}
            >
              <Switch>
                {clientRedirect && (
                  <Redirect exact from="/" to={clientRedirect.redirectTo} />
                )}
                {_.map(pages, (page, index) => {
                  if (page.isAvailable) {
                    return (
                      <Route
                        exact={
                          typeof page.exact !== 'undefined' ? page.exact : false
                        }
                        path={`/${page.path_name}`}
                        component={page.component}
                        key={index}
                      />
                    );
                  }

                  return null;
                })}
                <Route component={notAvailable} />
              </Switch>
            </div>
          </Suspense>
          {/* Staff-only global modals: company creation + time logging. These
                        assume staff-shaped data (e.g. user_role[0], globalConfig) and must
                        not mount for clients — LogActivity crashes on a client's missing
                        user_role. Default-deny on /me-derived user-kind: they mount only
                        once /me confirms Internal, so they never render for a client and
                        never render before /me resolves. CookieConsentModal stays universal. */}
          {isInternal && (
            <>
              <AddCompany />
              <Proceed
                history={this.props.history}
                projectId={project.Selected.id}
              />
              <LogActivity />
            </>
          )}
          <CookieConsentModal />
        </ResponsiveShell>
      </>
    );
  }
}

export default withRouter(Main);
